import { UserAttribution, UserDocument, userSchema } from 'models/user';

export function getValidUserDocument(
  uid: string,
  email: string,
  form: {
    name: string;
    opted_out: boolean;
  },
  attribution: UserAttribution | null
): UserDocument {
  const data: Partial<UserDocument> = {
    addresses: [],
    bikes: [],
    name: form.name,
    first: form.name.split(' ')[0],
    last: form.name.split(' ').slice(1).join(' '),
    phone: '',
    country: {
      code: 'US',
      name: 'United States',
      currency: 'USD',
    },
    account_activated: false,
    badge_counts: { quick_replies: 0, fast_shipper: 0, as_described: 0 },
    banned: false,
    brands: [],
    created: Date.now(),
    email,
    favorites: [],
    flag_count: 0,
    followers: 0,
    following: [],
    from_web: true,
    hide_status: false,
    is_verified: false,
    top_seller: false,
    on_vacation: false,
    // last_active: Date.now(),
    opted_out: form.opted_out,
    photo: `https://ui-avatars.com/api/?background=random&length=2&name=${
      form.name ? form.name.split(' ')[0] : 'User'
    }&size=256`,
    rating: 0,
    reviews: 0,
    seller_type: 'individual',
    uid,
    username: `user_${uid.slice(0, 10)}`,
    username_slug: `user_${uid.slice(0, 10)}`,
    username_changed: 0,
    platforms: ['web'],
  };
  if (attribution) {
    data.attribution = attribution;
  }
  const docData = userSchema.parse(data);
  return docData;
}
